import Analytics from "analytics";
import googleAnalytics from "@analytics/google-analytics";

const analytics = Analytics({
  app: "awesome-app",
  plugins: [
    googleAnalytics({
      trackingId: "UA-170388459-2",
    }),
  ],
});

const analyticsSpencer = Analytics({
  app: "awesome-app",
  plugins: [
    googleAnalytics({
      trackingId: "UA-74917832-1",
    }),
  ],
});

analytics.page();
analyticsSpencer.page();

const track = (label) => {
  analytics.track("generate_lead", {
    category: "",
    label: label,
  });
  analyticsSpencer.track("generate_lead", {
    category: "",
    label: label,
  });
};

export default track;
